import { GetActiveMemberStatus, IGetActiveMemberRequest } from '@ace-clublabs/common-membership-api-types';
import { GetActiveMember } from '../contracts/GetActiveMember';

export const GetActiveMemberStub: GetActiveMember = async (request: IGetActiveMemberRequest) => {
  return Promise.resolve({
    status: 'success',
    data: {
      isActiveMember: GetActiveMemberStatus.NOT_ACTIVE,
    },
  });

  // return Promise.resolve({
  //   status: 'success',
  //   data: { isActiveMember: GetActiveMemberStatus.ACTIVE },
  // });

  // return Promise.resolve({
  //   status: 'error',
  //   error: { some: 'error' },
  // });
};
